export const vars = {
  appName: 'O.R.C.A.',
  asideWidth: '18.05rem',
}
